var collapsible_list_component_rtlignore_default = {
  "ltr": "dLmbB",
  "rtl": "e89Oi",
  "iconContainer": "E4WbQ",
  "icon": "_6tZVK",
  "isExpanded": "ABeVT",
  "listDimensions": "JlYvR"
};
export {
  collapsible_list_component_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-component.rtlignore-scss.js.map
